import { useLocation, useNavigate } from 'react-router-dom';
// import CustomerTable from "./CustomerTable";

import { useCallback, useEffect, useState } from 'react';

import RestartAlt from '@mui/icons-material/RestartAlt';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { voucherService } from '../../services/voucherService';
import Tooltip from '@mui/material/Tooltip';
import { Table, Input } from 'antd';
import { formatCustomNumber } from '../../helpers/formatCustomNumber';
import { productSharingService } from '../../services/productSharing.service';
import { GetProductSharingAtom, SetProductSharingAtom } from '../../store/productSharingAtom';
import { formatCustomDate } from '../../helpers/formatCustomDate';
import { toLowercaseKeys } from '../../helpers/toLowerCaseKeys';
import GeneralCustomTable from '../../helpers/GeneralCustomTable';

const { Search } = Input;

function ProductSharingPage() {
  const { pathname } = useLocation();
  const productSharingAtom = GetProductSharingAtom();
  const setProductSharingAtom = SetProductSharingAtom();
  const navigate = useNavigate();
  var url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    //   document.title = 'Voucher Page'; product_sharing_group
    if (productSharingAtom?.product_sharing_info?.length < 1) {
      loadVoucherData();
    } else {
      setFilteredData(productSharingAtom?.product_sharing_info);
    }
  }, [productSharingAtom]);

  const reloadData = () => {
    loadVoucherData();
  };

  const loadVoucherData = () => {
    productSharingService.productSharingList().then(res => {
      if (res.data) {
        const serverData = toLowercaseKeys(res.data);
        setProductSharingAtom(serverData);
        if (serverData?.product_sharing_info?.length) {
          setFilteredData(serverData?.product_sharing_info);
        }
      }
    });
  };

  function addNew() {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
  }

  const columns = [
    {
      title: 'Ref',
      key: 'ref_no',
      dataIndex: 'ref_no',
      className: 'text-primary',
      sorter: (a, b) => (a?.ref_no ?? '') - (b?.ref_no ?? ''),
      //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
    },

    {
      title: 'Item Name',
      dataIndex: 'item_name',
      sorter: (a, b) => (a?.item_name ?? '').localeCompare(b?.item_name ?? ''),

      //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
    },

    {
      title: 'Slot Price',
      dataIndex: 'slot_price',
      sorter: (a, b) => (a?.slot_price ?? '') - (b?.slot_price ?? ''),
      render: slot_price => formatCustomNumber(slot_price),
    },
    {
      title: 'Slot Number',
      dataIndex: 'slot_number',
      sorter: (a, b) => (a?.slot_number ?? '') - (b?.slot_number ?? ''),
      render: Slot_Number => formatCustomNumber(Slot_Number),
    },
    {
      title: 'Purchased Slot',
      dataIndex: 'total_purchased_slot',
      sorter: (a, b) => (a?.total_purchased_slot ?? '') - (b?.slot_number ?? ''),
      render: total_purchased_slot => formatCustomNumber(total_purchased_slot),
    },
    {
      title: 'Remaining Slot',
      dataIndex: 'total_remaining_slot',
      sorter: (a, b) => (a?.total_remaining_slot ?? '') - (b?.total_remaining_slot ?? ''),
      render: total_remaining_slot => formatCustomNumber(total_remaining_slot),
    },
    {
      title: 'Status',
      dataIndex: 'item_status',
      sorter: (a, b) => a.item_status.localeCompare(b.item_status),
    },
    {
      title: ' Created Date',
      dataIndex: 'created_date',
      // sorter: (a, b) => a.Created_Date.localeCompare(b.Created_Date),
      render: created_date => formatCustomDate(created_date),
    },
    {
      title: ' Expire Date',
      dataIndex: 'gropool_date',
      // sorter: (a, b) => a.Created_Date.localeCompare(b.Created_Date),
      render: gropool_date => formatCustomDate(gropool_date),
    },
  ];

  const handleSearch = value => {
    setSearchText(value);
    const filtered = productSharingAtom.product_sharing_group.filter(record =>
      Object.values(record).some(text => String(text).toLowerCase().includes(value.toLowerCase()))
    );
    setFilteredData(filtered);
  };



  const handleRowClick = record => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${record?.ref_no}`);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: newSelectedRowKeys => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          {/* grid start */}
          <div className="row   mt-5 mb-2">
            <div className="col">
              <Tooltip title="Reload">
                <RestartAlt className="cursor ml-2 mt-2 mr-2" onClick={() => reloadData()} color="primary" fontSize="large" />
              </Tooltip>
            </div>

            <div className="col offset-3">
              <div className="flex  justify-end">
                {/* <button
                      style={{ backgroundColor: "#476EF8" }}
                      onClick={() => addNew()}
                      className=" mr-3  rounded text-white text-sm font-[Poppins] mt-1 py-[1.8vh]  px-3"
                    >
                      EXPORT
                    </button> */}
                <button
                  style={{ backgroundColor: '#476EF8' }}
                  onClick={() => addNew()}
                  className="  rounded text-white text-sm font-[Poppins] mt-1 py-[1.8vh]  px-3"
                >
                  ADD NEW
                </button>
              </div>
            </div>
          </div>
          {/* End of Grid */}
        </Grid>
      </Grid>

      <section className="mt-5   w-full">
        <div className="">
          <section className="mt-5">
            <GeneralCustomTable
              tableHeadList={columns}
              tableDataList={filteredData}
              allowCheckBox={false}
              // setSelectedRows={selectedTableItems}
              rowKey={record => record.Sales_Order_Ref_No}
              handleRowClick={handleRowClick}
            />
          </section>
        </div>
      </section>
    </>
  );
}

export default ProductSharingPage;
